import { render, staticRenderFns } from "./customer-credit.vue?vue&type=template&id=4682c9a0"
import script from "./customer-credit.vue?vue&type=script&lang=js"
export * from "./customer-credit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports